function getProductTileData(productTile) {
  let productData = {};
  productData.id = $(productTile).id ? $(productTile).id : $(productTile).data("id");
  let titleElement = $(productTile).find(".ProductItem__Title").find("a")[0];
  productData.title = titleElement.innerHTML;
  productData.url = titleElement.href;
  let productColorElement = $(productTile).find(".ProductColor")[0];
  productData.color = productColorElement.innerHTML;
  let productPriceElements = Array.from(
    $(productTile).find(".ProductItem__Price")
  );
  let productPriceElement = {};
  if (productPriceElements.length > 1) {
    for (let i in productPriceElements) {
      if (
        productPriceElements[i].innerHTML.includes("$") &&
        productPriceElements[i].classList.contains("Price--highlight")
      ) {
        productPriceElement = productPriceElements[i];
      }
    }
  } else {
    productPriceElement = productPriceElements[0];
  }
  if (!productPriceElement.innerHTML) {
    productPriceElement.innerHTML = "$see cart";
  }
  productData.price = productPriceElement.innerHTML;

  let productSizesElement = $(productTile).find(".ProductSizes__Wrapper")[0];
  let productImageElement = $(productTile).find("img")[1]
    ? $(productTile).find("img")[1]
    : $(productTile).find("img")[0];
  productData.image = productImageElement.srcset ? 
    productImageElement.srcset
    : productImageElement.src ? 
    productImageElement.src
    : productImageElement.dataset.src ?
     productImageElement.dataset.src.replace("_{width}x", "")
    : productImageElement.dataset.srcset.replace("_{width}x", "");
    
  let productQuickAddHeader =
    $(productSizesElement).find(".quick-add-header")[0];
  let optionsData = JSON.parse(productQuickAddHeader.dataset.options);
  for (let i in optionsData) {
    optionsData[i].name = optionsData[i].name.replace("_", " ");
  }
  productData.options = optionsData;
  let sizes = Array.from($(productSizesElement).find(".quick-add-size"));
  let variants = [];
  for (let i in sizes) {
    let variant = {};
    if (sizes[i].tagName === "DIV") {
      variant.available = false;
      variant.id = sizes[i].dataset.id;
      variant.sku = sizes[i].dataset.sku;
      variant.options = sizes[i].innerHTML.split(" / ");
    } else {
      variant.available = true;
      variant.id = sizes[i].elements["id"].value;
      variant.sku = sizes[i].elements["sku"].value;
      variant.options = sizes[i].elements["button"].value.split(" / ");
    }
    variants.push(variant);
  }
  productData.variants = variants;
  return productData;
}

let Labels = {
  soldout: "Sold out",
  addToCart: "Add to cart",
  unavailable: "Unavailable",
  default: "Make selection"
}
function addToCart(event) {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
  
  let imageElements = $(event.target).parent().parent().find("img");
  let image = imageElements.attr("src") ? imageElements.attr("src") : imageElements[0].dataset.srcset;
  let price = event.target.elements["price"] ? parseInt(event.target.elements["price"].value) : parseInt($(event.target).parent().parent().find(".quick-view__price").text().replace("$",""));
  let name = event.target.elements["name"] ? event.target.elements["name"].value : $(event.target).parent().parent().find(".quick-view__title").text();
  let options = event.target.elements["id"].options;
  let index = event.target.elements["id"].selectedIndex;
  let sku = event.target.elements["sku"] ? event.target.elements["sku"].value : options[index].dataset.sku

  let variantObject = {
    price,
    image,
    name,
    sku 
  };

  $.post(window.Shopify.routes.root + 'cart/add.js', $(event.target).serialize()).then((res)=>{
    document.dispatchEvent(new CustomEvent('product:added', {
      bubbles: false,
      detail: {
        variant: variantObject,
        quantity: 1
      }
    }));
    document.dispatchEvent(new CustomEvent('product:quickadded', event));
  });
 
  return false;
}

function sizeSelect(e) {
  let form = $(e.target).closest("form");

  let options = Array.from($(form).find(".ProductForm__Option:not(.no-js)"));

  let selectedOptions = Array.from($(form).find("input:checked"));
  let modalIDsContainer = $(form).find(".selected_SKU")[0];
  let IDOptions = modalIDsContainer.options;
  let variantOptions = Array.from(modalIDsContainer.options);
  let selectedValue = "";
  let addButton = $("#QuickViewModal").find(".ProductForm__AddToCart")[0];
  let addButtonSpan = $(addButton).find("span")[0];
  let match = false;
  let soldout = false;

  if (selectedOptions.length === options.length) {
    for (let i in selectedOptions) {
      if (i != 0) {
        selectedValue += " / ";
      }
      selectedValue += selectedOptions[i].value;
    }
    for (let i in IDOptions) {
      if (selectedValue === IDOptions[i].innerHTML) {
        match = true;
        modalIDsContainer.value = IDOptions[i].value;
        soldout = IDOptions[i].disabled;
        addButton.disabled = soldout;

        if (soldout) {
          addButtonSpan.innerHTML = Labels.soldout;
        } else {
          addButtonSpan.innerHTML = Labels.addToCart;
        }
      }
    }
    if (!match) {
      addButtonSpan.innerHTML = Labels.unavailable;
      addButton.disabled = true;
    }
  }
}
function toggleQuickAddModal(e) {
  let quickViewModal = $("#QuickViewModal")[0];

  if (
    e.target.classList.contains("modal__overlay") ||
    e.target.classList.contains("modal__close")
  ) {
    let addButton = $("#QuickViewModal").find(".ProductForm__AddToCart")[0];
    addButton.disabled = true;
    e.preventDefault();
    quickViewModal.setAttribute("aria-hidden", "true");
    quickViewModal.classList.toggle("is-active");
  }
}

function switchMobileQuickAddModalInfo(productData) {
  let quickViewModal = $("#QuickViewModal")[0];
  quickViewModal.setAttribute("aria-hidden", "false");
  quickViewModal.classList.toggle("is-active");
  let addButton = $("#QuickViewModal").find(".ProductForm__AddToCart")[0];
  let addButtonSpan = $(addButton).find("span")[0];
  addButtonSpan.innerHTML = Labels.default;
  addButton.disabled = true;

  let modalTitleContainer = $("#QuickViewModal").find(
    ".quick-view__title-container"
  )[0];
  let modalTitleDiv = modalTitleContainer.children[0];
  let modalColorDiv = modalTitleContainer.children[1];

  let modalVariantsContainer = $("#QuickViewModal").find(
    ".ProductForm__Variants"
  )[0];

  let modalSizesContainer = $("#QuickViewModal").find(".SizeSwatchList")[0];
  let modalIDsContainer = $("#QuickViewModal").find(".selected_SKU")[0];

  let modalPriceContainer = $("#QuickViewModal").find(
    ".quick-view__price-container"
  )[0];
  let modalPriceDiv = modalPriceContainer.children[0];
  let modalDetailsLink = modalPriceContainer.children[1];
  let modalImageElement = $("#QuickViewModal").find(".quick-view__image")[0];

  modalImageElement.src = productData.image;
  modalTitleDiv.innerHTML = productData.title;
  modalDetailsLink.href = productData.url;
  modalColorDiv.innerHTML = "Color: " + productData.color;
  modalPriceDiv.innerHTML = productData.price;

  let modalSizes = Array.from(
    $(modalVariantsContainer).children(".ProductForm__Option:not(.no-js)")
  );
  let modalIDs = Array.from(modalIDsContainer.options);
  modalIDsContainer.id = `product-select-${productData.id}`;
  for (let i in modalSizes) {
    let sizes = Array.from($(modalSizes[i]).find("li"));

    let l = sizes.length;
    for (let i = 1; i < l; i++) {
      sizes[i].remove();
    }
  }
  let len = modalIDs.length;
  for (let i = 1; i < len; i++) {
    modalIDs[i].remove();
  }
  let variants = productData.variants;
  let options = productData.options;

  for (let i in options) {
    let optionName = document.createElement("label");

    optionName.innerHTML = options[i].name;
    let values = options[i].values;

    let clonedSizeDiv = modalSizes[0].cloneNode(true);
    let optionLabel = $(clonedSizeDiv).find(".ProductForm__Label")[0];
    optionLabel.innerHTML = options[i].name;
    let sizesContainer = $(clonedSizeDiv).find(".SizeSwatchList")[0];

    for (let k in values) {
      let clonedSizeElement = $(sizesContainer)
        .find(".swatch-element")[0]
        .cloneNode(true);
      let input = $(clonedSizeElement).find("input")[0];

      if (!input) {
        input = document.createElement("input");
        input.type = "radio";
        input.className = "SizeSwatch__Radio";
        clonedSizeElement.prepend(input);
      }
      let label = $(clonedSizeElement).find("label")[0];

      input.checked = false;
      input.id = `option-${i}-${k}`;
      input.value = values[k];
      input.name = `option-${i}`;

      label.classList.remove("quick_size_button");

      label.classList.remove("not-available");
      label.setAttribute("for", input.id);

      label.innerHTML = values[k];

      sizesContainer.appendChild(clonedSizeElement);
      clonedSizeDiv.appendChild(sizesContainer);
    }
    modalVariantsContainer.appendChild(clonedSizeDiv);

    sizesContainer.children[0].remove();
  }

  for (let i in variants) {
    
    let clonedIDDiv = modalIDs[0].cloneNode(true);
    clonedIDDiv.innerHTML = variants[i].options.join(" / ");
    clonedIDDiv.value = variants[i].id;

    clonedIDDiv.disabled = !variants[i].available;

    clonedIDDiv.dataset.sku = variants[i].sku;
    modalIDsContainer.appendChild(clonedIDDiv);
  }
  if (modalIDs.length > 1) {
    modalIDs[0].remove();
  }
  for (let i in modalSizes) {
    modalSizes[i].remove();
  }
}

function quickAddSetup(
  containerSelector,
  productSelector,
  buttonSelector,
  dataFunction
) {
  let modal = $("#QuickViewModal")[0];
  if(modal){
    $(modal).on("click", toggleQuickAddModal);
    let form = $(modal).find("#product-form")[0];
    $(form).on("change", sizeSelect);
            $(form).on("submit", addToCart);

    let addButton = $(modal).find(".ProductForm__AddToCart")[0];
    let addButtonSpan = $(addButton).find("span")[0];
    addButtonSpan.innerHTML = Labels.default;
  //  $(addButton).on("click", addToCart);
    
    $(containerSelector).on("click", buttonSelector, (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.cancelBubble = true;
      let productTile = $(e.target).closest(productSelector);
      let data = dataFunction(productTile);
  
      switchMobileQuickAddModalInfo(data);
    });
  }
  $(document).on("submit", ".quick-add-size", addToCart);

 
}

quickAddSetup(
  ".ProductList",
  ".Grid__Cell:not(.section-block)",
  ".view-quick-add",
  getProductTileData
);
